import { useState } from "react";
import { LineChart } from "lucide-react";

import FinancialModelForm from "@/components/FinancialModelForm";
import FundingCta from "@/components/FundingCta";
import { parseModelQuery } from "@/lib/financialModelMath";

export default function FinancialModel() {
  // Full width for every role — see PageShell in components/interior-page.tsx.
  const shellWidth = "w-full";
  // A shared link (or a listing hand-off) arrives as query params; read once on mount.
  const [shared] = useState(() => parseModelQuery(window.location.search));

  return (
    <div className="public-stage pb-10">
      <div className={`${shellWidth} px-4 py-8 sm:px-6 lg:px-8`}>
        {/* Header — same Dark · Gold hero as the SBA and Valuation calculators */}
        <section className="public-hero-shell mb-7 rounded-[1.85rem] px-6 py-7 shadow-glow sm:px-8">
          <div className="public-grid-lattice absolute inset-0 opacity-45" />
          <div className="absolute -right-14 top-0 h-40 w-40 rounded-full bg-white/30 blur-3xl" />
          <div className="relative z-10">
            <div className="public-pill">
              <LineChart className="h-3.5 w-3.5" />
              Financial Model
            </div>
            <h1 className="mt-4 font-display text-3xl leading-tight text-foreground sm:text-4xl">
              5-Year <span className="text-gradient">Financial Model</span>
            </h1>
            <p className="mt-2 max-w-2xl text-sm leading-7 text-muted-foreground sm:text-base">
              A full acquisition pro forma — free cash flow after taxes and debt, DSCR every year, the exit, and your
              IRR. Stress-test it with downside and upside cases. Updates live as you type.
            </p>
          </div>
        </section>

        <FinancialModelForm initialValues={shared} persist />
        <FundingCta className="mt-6" />
      </div>
    </div>
  );
}
